module.exports = __webpack_public_path__ + "img/67200.f1b8f6c4.jpg";